import { FETCH_ACCOUNT_DELETE_REQUEST } from 'actions/accountDeleteRequest';

const initialState = {
  isLoading: false,
  accountDeleteRequest: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const accountDeleteRequestReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_ACCOUNT_DELETE_REQUEST.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_ACCOUNT_DELETE_REQUEST.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        accountDeleteRequest: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case FETCH_ACCOUNT_DELETE_REQUEST.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default accountDeleteRequestReducer;
